import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    loadComponent: () =>
      import('./page/customer/welcome/welcome.component').then((c) => c.WelcomeComponent),
  },
  {
    path: 'pickup',
    loadComponent: () =>
      import('./page/customer/pickup/pickup.component').then((c) => c.PickupComponent),
  },
  {
    path: 'support',
    loadComponent: () =>
      import('./page/customer/tech-support/tech-support.component').then(
        (c) => c.TechSupportComponent,
      ),
  },
  {
    path: 'service',
    loadChildren: () => import('./page/service/service-base/service-routes').then((c) => c.routes),
  },
  {
    path: '**',
    redirectTo: 'welcome',
  },
];
